import { Address, AddressData, AddressForm, DigitalAddress } from '../../../global-types/addresses';

export enum AddressAction {
  SetAddressData = 'address/setAddressData',
  SetRecipientAddress = 'address/setRecipientAddress',
  SetSenderAddress = 'address/setSenderAddress',
  ResetSenderAndRecipientAddresses = 'address/resetSenderAndRecipientAddresses',
  UpdateDigitalAddress = 'address/updateDigitalAddress',
  SetIsRecipientAddress = 'address/setIsRecipientAddress',
  CleanAddresses = 'address/cleanAddresses',
  Reset = 'address/reset',
}

export type AddressDataType = {
  recipient: AddressData | null;
  sender: AddressData | null;
  digital: DigitalAddress | Address | null;
};

export type AddressState = {
  addressData: AddressDataType;
  isRecipientAddress: boolean;
};

export type AddressActions = {
  setAddressData: (params: { recipient?: AddressData; sender?: AddressData }) => void;
  setRecipientAddress: (address: AddressForm) => void;
  setSenderAddress: (address: AddressForm) => void;
  resetSenderAndRecipientAddresses: () => void;
  updateDigitalAddress: (address: DigitalAddress | Address) => void;
  setIsRecipientAddress: (isRecipientAddress: boolean) => void;
  cleanAddresses: () => void;
  reset: () => void;
};

export type AddressSlice = AddressState & AddressActions;
